import InputGroupsContainer from "../../../../components/formsAndTable/forms/formControls/inputGroups";

const InputGroup = () => {
  return <InputGroupsContainer />;
};

export default InputGroup;
